<template>
  <div class="rounded-b-3xl bg-light-gray-200 py-10 lg:py-14">
    <div class="container text-center">
      <CircleButton
        class="mb-6 transition-opacity duration-300 lg:mb-3"
        :class="heroAnimated ? 'opacity-100' : 'opacity-0'"
        iconName="checked"
        color="blue"
        size="md"
        iconSize="md"
      />
      <Heading
        v-if="data.title"
        :semantic="isSemantic"
        :level="level"
        class="mx-auto mb-6 max-w-3xl text-3xl font-light text-blue-950 lg:text-5xl"
        @completed="heroAnimated = true"
      >
        {{ data.title }}
      </Heading>
      <div
        v-if="data.subtitle"
        class="mx-auto mb-6 max-w-2xl text-base text-neutral-500 transition-opacity duration-300 lg:mb-10"
        :class="heroAnimated ? 'opacity-100' : 'opacity-0'"
        v-html="data.subtitle"
      />

      <CallToAction
        v-if="Array.isArray(data.buttons) && data.buttons.length"
        class="mx-auto !flex-col gap-3 transition-opacity duration-300 lg:!flex-row lg:gap-0"
        :class="heroAnimated ? 'opacity-100' : 'opacity-0'"
        :data="data.buttons"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from '~/stores/AppStore'
import type { SectionThankYouRecord } from '~/types/generated'
const store = useAppStore()
const heroAnimated = ref(false)

const props = defineProps({
  data: {
    type: Object as PropType<SectionThankYouRecord>,
    default: () => {}
  },
  index: {
    type: Number,
    required: true
  }
})

const { level, isSemantic } = useSectionRules(props.index, !!props.data.title)

onMounted(() => {
  store.setTheme('white')
})
</script>
